import React from 'react';
import { I18n } from '@aws-amplify/core';

import { DetailsTable } from './DetailsTable/DetailsTable';
import { Conclusion } from './Conclusion';
import { ReportTemplate } from '@/components/views/Report/ReportTemplate';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useHistory } from 'react-router-dom';

export const Result = ({
	file,
	report,
	sectors,
	formatReport,
	onDownloadPDF,
	isLoadingPDF,
	onChangeComment
}) => {
	const history = useHistory();
	const { organization, company, isSandbox, sendReport, existsReport } = useApplicationContext();


	function handleSendReport() {
		const request = {
			report_type: 'STRAIN_INDEX',
			id: report.data.id || '',
			company_id: company?.id,
			organization_id: organization?.id
		};

		sendReport(request, '/reporting');

		const currentPath = history.location.pathname;
		const cleanPath = currentPath.match(/(\/reporting\/strain-index)/)?.[1];

		if (cleanPath && currentPath !== cleanPath) {
			history.replace(cleanPath);
		}
	}

	const exists = existsReport({
		file_id: file.data.id,
		company_id: company?.id,
		organization_id: organization?.id,
		report_type: 'STRAIN_INDEX'
	});

	const formattedReport = formatReport(report.data);

	const sections = [
		{
			title: I18n.get('Conclusion'),
			component: <Conclusion formattedReport={formattedReport} />
		},
		{
			title: I18n.get('Details'),
			component: <DetailsTable formattedReport={formattedReport} />
		}
	];

	const isLoading = report?.isLoading || sectors?.isLoading || !formattedReport;
	const selectedSector = sectors.data.find((sector) => sector.id === file.data.sector_id);

	return (
		<ReportTemplate
			title={I18n.get('Report Results - Revised Strain Index')}
			sections={sections}
			sector={selectedSector}
			fileData={file.data}
			reportData={report.data}
			isLoading={isLoading}
			onDownloadPDF={onDownloadPDF}
			isLoadingPDF={isLoadingPDF}
			onChangeComment={onChangeComment}
			reportType='STRAIN_INDEX'
			handleSendReport={handleSendReport}
			exists={exists}
		/>
	);
};
